export default "__VITE_ASSET__BfZiHq5Z__"